export default "<div>\n  {{ '404 Error' }}\n</div>\n";